var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandingAndCustomizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 2.495 0.78 0.92 2 0C2 0.845 2.69 2 4 2C4.79565 2 5.55871 2.31607 6.12132 2.87868C6.68393 3.44129 7 4.20435 7 5C7 5.386 6.921 5.752 6.788 6.091C7.52976 6.67969 8.26022 7.28247 8.979 7.899L6.899 9.979C6.28271 9.26002 5.67994 8.52956 5.091 7.788C4.74387 7.92653 4.37375 7.99845 4 8C1.79 8 0 6.21 0 4ZM12.152 10.848L13.493 9.507C14.114 9.8267 14.8016 9.99559 15.5 10C16.6935 10 17.8381 9.52589 18.682 8.68198C19.5259 7.83807 20 6.69347 20 5.5C20 4.775 19.812 4.099 19.507 3.493L16 7L14 5L17.507 1.493C16.886 1.1733 16.1984 1.00441 15.5 1C14.3065 1 13.1619 1.47411 12.318 2.31802C11.4741 3.16193 11 4.30653 11 5.5C11 6.225 11.188 6.901 11.493 7.507L1 18L3 20L9.848 13.152C11.7314 15.0844 13.7272 16.9039 15.825 18.601L17.25 19.75L18.75 18.25L17.601 16.825C15.9039 14.7272 14.0844 12.7314 12.152 10.848Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingAndCustomizationIcon);
export default __webpack_public_path__ + "static/media/branding-and-customization-icon.4716145418f2d65410d3ce2aee92283a.svg";
export { ForwardRef as ReactComponent };